import React from 'react'
import { Text } from '~/themes/styles'

export const InlineBold = ({ children }) => (
  <Text bold display="inline">
    {children}
  </Text>
)
